import React, { useState, useEffect } from 'react';
import './TransformerThree.css';
import Transformer2Four from "./Transformer2Four";


const TransformerTestForm = ({ goBack }) => {



  const isObject = (item) => {
    return item && typeof item === 'object' && !Array.isArray(item);
  };
  


  const deepMerge = (target, source) => {
    if (!isObject(target) || !isObject(source)) {
      return source !== undefined ? source : target;
    }

    const output = { ...target };


    Object.keys(source).forEach(key => {
      const sourceValue = source[key];
      const targetValue = target[key];


      if (sourceValue === undefined) {
        return;
      }


      if (sourceValue === null) {
        output[key] = null;
        return;
      }


      if (Array.isArray(sourceValue)) {

        if (sourceValue.length > 0 && sourceValue[0] && isObject(sourceValue[0])) {

          output[key] = sourceValue.map((sourceItem, index) => {
            if (isObject(sourceItem)) {

              const targetItem = Array.isArray(targetValue) && targetValue[index] ? targetValue[index] : {};
              if (isObject(targetItem)) {

                return deepMerge(targetItem, sourceItem);
              }

              return sourceItem;
            }
            return sourceItem;
          });
        } else {

          output[key] = sourceValue;
        }
      }

      else if (isObject(sourceValue)) {
        if (isObject(targetValue)) {

          output[key] = deepMerge(targetValue, sourceValue);
        } else {

          output[key] = sourceValue;
        }
      }

      else {

        output[key] = sourceValue;
      }
    });

    return output;
  };


 
const createDefaultState = () => ({
  formData: {},
  rows: [],
  generalInspection: {},
  lvType: 'LV2',
  vectorGroupTest: {
    test1: "",
    test2: "",
    test3: "",
    lv2test1: "",
    lv2test2: "",
    lv2test3: "",
    lv3test1: "",
    lv3test2: "",
    lv3test3: "",
    lv4test1: "",
    lv4test2: "",
    lv4test3: ""
  },
 vectorGroupImages: {
       image1: "https://i.ibb.co/nskc05qY/Screenshot-2025-06-30-123336.png",
       image2: "https://i.ibb.co/BHSqZ9r7/Screenshot-2025-06-30-123657.png",
       image3: "https://i.ibb.co/gL8GDxvs/Screenshot-2025-06-30-123840.png"
     },
  numberOfTaps: 1,
  magneticBalanceTaps: 1,
  magneticBalanceLVs: 1,
  numberOfLVs: 1, 
  magneticBalanceData: {
    hv: Array(5).fill().map(() => ({
      '1U-1N': Array(6).fill(""),
      '1V-1N': Array(6).fill(""),
      '1W-1N': Array(6).fill("")
    })),
    lv: Array(5).fill().map(() => ({
      '1U-1N': Array(12).fill(""),
      '1V-1N': Array(12).fill(""),
      '1W-1N': Array(12).fill("")
    }))
  },
  windingResistance: {
    hvWinding: Array(1).fill().map(() => Array(3).fill("").map(() => ({ value: "", unit: "mΩ" }))),
    lv1Winding: Array(3).fill("").map(() => ({ value: "", unit: "mΩ" })),
    lv2Winding: Array(3).fill("").map(() => ({ value: "", unit: "mΩ" })),
    lv3Winding: Array(3).fill("").map(() => ({ value: "", unit: "mΩ" })),
    lv4Winding: Array(3).fill("").map(() => ({ value: "", unit: "mΩ" }))
  },
  windingRefs: {
    "LV1WT1CT": "",
    "LV2WT1CT": "",
    "LV3WT1CT": "",
    "LV4WT1CT": "",
    "HVWT1CT": ""
  },
  insulationData: {
    "HV-E": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "HV-LV1": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "HV-LV2": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "HV-LV3": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "HV-LV4": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV1-E": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV2-E": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV3-E": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV4-E": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV1-LV2": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV1-LV3": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV1-LV4": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV2-LV3": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV2-LV4": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" },
    "LV3-LV4": { appliedVoltage: "", min1: "", min1Unit: "MΩ", min10: "", min10Unit: "MΩ", pi: "" }
  },
  bushingData: [
    { description: "LV1 WT1 CT", terminal: "S1 - S2", irTest: "", windingResistance: "", windingRef: "" },
    { description: "LV2 WT1 CT", terminal: "S1 - S2", irTest: "", windingResistance: "", windingRef: "" },
    { description: "LV3 WT1 CT", terminal: "S1 - S2", irTest: "", windingResistance: "", windingRef: "" },
    { description: "LV4 WT1 CT", terminal: "S1 - S2", irTest: "", windingResistance: "", windingRef: "" },
    { description: "HV WT1 CT", terminal: "S1 - S2", irTest: "", windingResistance: "", windingRef: "" }
  ]
});




const [isInitialized, setIsInitialized] = useState(false);


const [formState, setFormState] = useState(() => {
  const defaultState = createDefaultState();

  try {
    const storedData = localStorage.getItem('transformerMagneticBalanceData_Dyn11');
    if (storedData) {
      const parsed = JSON.parse(storedData);
      if (parsed && Object.keys(parsed).length > 0) {
        const merged = { ...defaultState };

        Object.keys(parsed).forEach(key => {
          if (key !== 'vectorGroupTest') {
            merged[key] = deepMerge(defaultState[key], parsed[key]);
          }
        });

       
        if (parsed.numberOfLVs !== undefined && parsed.numberOfLVs !== null && parsed.numberOfLVs !== '') {
          merged.numberOfLVs = parseInt(parsed.numberOfLVs, 10);
        } else {
        
          merged.numberOfLVs = 1; 
        }

        if (parsed.vectorGroupTest && typeof parsed.vectorGroupTest === 'object') {
          merged.vectorGroupTest = {
            ...defaultState.vectorGroupTest,
            ...parsed.vectorGroupTest
          };
        } else {
          merged.vectorGroupTest = defaultState.vectorGroupTest;
        }

    
        if (parsed.magneticBalanceData) merged.magneticBalanceData = parsed.magneticBalanceData;
        if (parsed.windingResistance) merged.windingResistance = parsed.windingResistance;
        if (parsed.bushingData) merged.bushingData = parsed.bushingData;
        if (parsed.insulationData) merged.insulationData = parsed.insulationData;
        if (parsed.windingRefs) merged.windingRefs = parsed.windingRefs;
        if (parsed.lvType) merged.lvType = parsed.lvType;
        if (parsed.magneticBalanceTaps) merged.magneticBalanceTaps = parsed.magneticBalanceTaps;
        if (parsed.magneticBalanceLVs) merged.magneticBalanceLVs = parsed.magneticBalanceLVs;

    
        try {
          const imagesData = localStorage.getItem('transformerVectorGroupImages_Dyn11');
          if (imagesData) {
            const parsedImages = JSON.parse(imagesData);
            if (parsedImages.vectorGroupImages) {
              merged.vectorGroupImages = {
                ...defaultState.vectorGroupImages,
                ...parsedImages.vectorGroupImages
              };
            }
          }
        } catch (e) {
          console.error('Error loading images:', e);
        }

        return merged;
      }
    }
  } catch (e) {
    console.error('Error loading state:', e);
  }
  
  return defaultState;
});

  const [showTestPage, setShowTestPage] = useState(false);

  const resistanceUnits = ["TΩ", "GΩ", "MΩ", "KΩ", "Ω"];
  const windingResistanceUnits = ["Ω", "mΩ"];
  const voltageOptions = ["250", "500", "1000", "1500", "2000", "2500", "5000"];


  const validateNumericInput = (value) => {
    if (value === '') return '';

    const numericRegex = /^(>|<|>=|<=)?\s*-?\d*\.?\d*$/;
    if (numericRegex.test(value)) {
      return value;
    }
    return null;
  };


  const extractNumericValue = (value) => {
    if (typeof value !== 'string') return NaN;

    const numericPart = value.replace(/^(>|<|>=|<=)\s*/, '');
    return parseFloat(numericPart);
  };


  const saveVectorGroupImagesToLocalStorage = () => {
    try {
      const vectorGroupImagesData = {
        vectorGroupImages: formState.vectorGroupImages,
        timestamp: new Date().getTime()
      };
      localStorage.setItem('transformerVectorGroupImages_Dyn11', JSON.stringify(vectorGroupImagesData));
      
    } catch (error) {
     
    }
  };


const loadVectorGroupImagesFromLocalStorage = () => {
    try {
      const storedImagesData = localStorage.getItem('transformerVectorGroupImages_Dyn11');

      if (storedImagesData) {
        const parsedImagesData = JSON.parse(storedImagesData);

        setFormState(prevState => {
          if (parsedImagesData.vectorGroupImages) {
            return {
              ...prevState,
              vectorGroupImages: {
                ...prevState.vectorGroupImages,
                ...parsedImagesData.vectorGroupImages
              }
            };
          }
          return prevState;
        });

        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  const saveToLocalStorage = () => {
    if (!isInitialized) {
  
      return;
    }
    try {
      
      localStorage.setItem('transformerMagneticBalanceData_Dyn11', JSON.stringify(formState));

      saveVectorGroupImagesToLocalStorage();
    } catch (error) {
      
    }
  };

const loadFromLocalStorage = () => {
  try {
    const storedData = localStorage.getItem('transformerMagneticBalanceData_Dyn11');
    
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setFormState(prevState => {
        const merged = deepMerge(prevState, parsedData);

        if (parsedData.numberOfLVs !== undefined && parsedData.numberOfLVs !== null && parsedData.numberOfLVs !== '') {
          merged.numberOfLVs = parseInt(parsedData.numberOfLVs, 10);
        }

        if (parsedData.vectorGroupTest && typeof parsedData.vectorGroupTest === 'object') {
          merged.vectorGroupTest = {
            ...prevState.vectorGroupTest,
            ...parsedData.vectorGroupTest
          };
        }

        return merged;
      });
    }


    loadVectorGroupImagesFromLocalStorage();
  } catch (error) {
    console.error('Error loading from localStorage:', error);
  }
};


  const initializeVectorGroupImages = () => {
    const imagesLoaded = loadVectorGroupImagesFromLocalStorage();

    if (!imagesLoaded) {

    
      saveVectorGroupImagesToLocalStorage();
    }
  };

  const handleMagneticBalanceTapsChange = (e) => {
    const value = parseInt(e.target.value, 10);
    updateFormState('magneticBalanceTaps', value);
  };


  const handleNumberOfTapsChange = (e) => {
    const value = parseInt(e.target.value, 10);
    updateFormState('numberOfTaps', value);
  };


  useEffect(() => {
    const requiredTaps = parseInt(formState.numberOfTaps) || 5;
    const currentTaps = formState.windingResistance.hvWinding.length;

    if (currentTaps !== requiredTaps) {
      setFormState(prev => {
        const newHvWinding = Array(requiredTaps).fill().map((_, index) => {

          if (index < currentTaps && prev.windingResistance.hvWinding[index]) {
            return prev.windingResistance.hvWinding[index];
          }

          return Array(3).fill("").map(() => ({ value: "", unit: "mΩ" }));
        });

        return {
          ...prev,
          windingResistance: {
            ...prev.windingResistance,
            hvWinding: newHvWinding
          }
        };
      });
    }
  }, [formState.numberOfTaps]);

  useEffect(() => {

    const imagesData = localStorage.getItem('transformerVectorGroupImages_Dyn11');
    if (!imagesData) {
      initializeVectorGroupImages();
    }

    try {
      const transformerFormData = localStorage.getItem('transformerFormData');
      if (transformerFormData) {
        const parsedData = JSON.parse(transformerFormData);
        if (parsedData.formData && parsedData.formData.numberOfTaps) {
          const tapsCount = parseInt(parsedData.formData.numberOfTaps) || 5;
          setFormState(prevState => {

            if (prevState.numberOfTaps !== tapsCount) {
              return {
                ...prevState,
                numberOfTaps: tapsCount

              };
            }
            return prevState;
          });
        }
      }
    } catch (error) {
      
    }
  }, []);


 
  useEffect(() => {
  const updatedInsulationData = { ...formState.insulationData };
  let hasChanges = false;

  Object.keys(updatedInsulationData).forEach(key => {
    const min1Value = extractNumericValue(updatedInsulationData[key].min1);
    const min10Value = extractNumericValue(updatedInsulationData[key].min10);

    const newPi = (!isNaN(min1Value) && !isNaN(min10Value) && min1Value !== 0)
      ? (min10Value / min1Value).toFixed(2)
      : "";

    if (updatedInsulationData[key].pi !== newPi) {
      updatedInsulationData[key].pi = newPi;
      hasChanges = true;
    }
  });

  if (hasChanges) {
    setFormState(prev => ({
      ...prev,
      insulationData: updatedInsulationData
    }));
  }
}, [
  Object.keys(formState.insulationData).map(key => 
    `${formState.insulationData[key].min1}-${formState.insulationData[key].min10}`
  ).join('|')
]);

  useEffect(() => {

    try {
      const storedData = localStorage.getItem('transformerMagneticBalanceData_Dyn11');
      if (storedData) {
        const parsed = JSON.parse(storedData);
        setFormState(prevState => {
          let needsUpdate = false;
          const updates = { ...prevState };


          if (parsed.numberOfLVs !== undefined && parsed.numberOfLVs !== null) {
            const parsedLVs = parseInt(parsed.numberOfLVs, 10);
            if (prevState.numberOfLVs !== parsedLVs) {
              updates.numberOfLVs = parsedLVs;
              needsUpdate = true;
            }
          }


          if (parsed.vectorGroupTest && typeof parsed.vectorGroupTest === 'object') {
            updates.vectorGroupTest = {
              ...prevState.vectorGroupTest,
              ...parsed.vectorGroupTest
            };
            needsUpdate = true;
          }

          return needsUpdate ? updates : prevState;
        });
      }
    } catch (error) {
    
    } finally {
      setIsInitialized(true);
    }
  }, []);



  useEffect(() => {
    const timeoutId = setTimeout(() => {
      saveToLocalStorage();
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [formState]);


  useEffect(() => {
    return () => {
      saveToLocalStorage();
    };
  }, []);

  const updateFormState = (key, value) => {
    setFormState(prev => ({
      ...prev,
      [key]: value
    }));
  };


  const handleVectorGroupChange = (testNumber, value) => {
    setFormState(prev => ({
      ...prev,
      vectorGroupTest: {
        ...prev.vectorGroupTest,
        [testNumber]: value
      }
    }));
  };

  const handleLvTypeChange = (newType) => {
    setFormState(prev => ({
      ...prev,
      lvType: newType
    }));
  };




  const handleNumberOfLVsChange = (e) => {
    const value = parseInt(e.target.value, 10);
    updateFormState('numberOfLVs', value);
  };

  const handleCurrentTapChange = (e) => {
    updateFormState('currentTap', e.target.value);
  };

  const handleMagneticBalanceChange = (testType, testIndex, condition, index, value) => {
    const validatedValue = validateNumericInput(value);
    if (validatedValue === null) return;

    setFormState(prev => {
      const updated = { ...prev };
      updated.magneticBalanceData[testType][testIndex][condition][index] = validatedValue;
      return updated;
    });
  };

  const handleInsulationChange = (key, field, value) => {
    if (field === 'min1' || field === 'min10') {
      const validatedValue = validateNumericInput(value);
      if (validatedValue === null) return;
      value = validatedValue;
    }

    setFormState(prev => {
      const updated = { ...prev };
      updated.insulationData[key][field] = value;
      return updated;
    });
  };

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };

  const handleWindingRefClick = (rowId, refValue) => {
    setFormState(prev => {
      const updated = { ...prev };
      updated.windingRefs[rowId] = prev.windingRefs[rowId] === refValue ? "" : refValue;
      return updated;
    });
  };

  const handleWindingResistanceChange = (windingType, tapIndex, posIndex, field, value) => {
    if (field === 'value') {
      const validatedValue = validateNumericInput(value);
      if (validatedValue === null) return;
      value = validatedValue;
    }

    setFormState(prev => {
      const updated = { ...prev };
      if (windingType === 'hvWinding') {
        updated.windingResistance[windingType][tapIndex][posIndex][field] = value;
      } else {
        updated.windingResistance[windingType][posIndex][field] = value;
      }
      return updated;
    });
  };

  const handleBushingDataChange = (index, field, value) => {
    if (field === 'irTest' || field === 'windingResistance') {
      const validatedValue = validateNumericInput(value);
      if (validatedValue === null) return;
      value = validatedValue;
    }

    setFormState(prev => {
      const updated = { ...prev };
      updated.bushingData[index][field] = value;
      return updated;
    });
  };

  const handleBack = () => {

    try {

      localStorage.setItem('transformerMagneticBalanceData_Dyn11', JSON.stringify(formState));
      saveVectorGroupImagesToLocalStorage();
    } catch (error) {
      
    }
    if (goBack) {
      goBack();
    }
  };

  const handleNext = () => {

    try {

      localStorage.setItem('transformerMagneticBalanceData_Dyn11', JSON.stringify(formState));
      saveVectorGroupImagesToLocalStorage();
    } catch (error) {
     
    }
    setShowTestPage(true);
  };

  const renderLVWindingCards = () => {
    const cards = [];

    for (let i = 1; i <= formState.numberOfLVs; i++) {
      const windingKey = `lv${i}Winding`;
      cards.push(
        <div key={i} className="ct-7337-winding-card">
          <h2 className="hello">LV{i} Winding (mΩ)</h2>
          <div className="ct-7339-table-container">
            <table className="ct-7340-winding-table">
              <thead>
                <tr>
                  <th className="ct-7329-label-span">{i + 1}U - {i + 1}V</th>
                  <th className="ct-7329-label-span">{i + 1}V - {i + 1}W</th>
                  <th className="ct-7329-label-span">{i + 1}W - {i + 1}U</th>
                </tr>
              </thead>
              <tbody>
                <tr className="ct-7331-table-row">
                  {[0, 1, 2].map((posIndex) => (
                    <td key={`lv${i}-${posIndex}`} className="ct-7333-input-cells">
                      <input
                        type="text"
                        className="ct-7334-input-cell"
                        value={formState.windingResistance[windingKey]?.[posIndex]?.value || ""}
                        onChange={(e) => handleWindingResistanceChange(windingKey, 0, posIndex, 'value', e.target.value)}
                        placeholder="Enter resistance (e.g., >10, <5)"
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return cards;
  };

  if (showTestPage) {
    return (
      <Transformer2Four
        goBack={() => {
          loadFromLocalStorage();
          setShowTestPage(false);
        }}
        savedGeneralData={formState}
      />
    );
  }

  return (
    <div className="ct-7319-transformer-test-form">

      <span
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '20px',
          fontWeight: '600',
          color: '#333',
          cursor: 'pointer',
          marginLeft: '50px',
          marginBottom: '50px'
        }}
        onClick={redirectToHome}
      >
        X
      </span>

      <div className="ct-2223">
        <h2 className='hello'>VECTOR GROUP TEST</h2> <br />


        <div className="lv-type-selection">
          <label className="lv-type-label">
            Select LV Type:
          </label>
          <div className="lv-type-options">
            <label className={`lv-type-option ${formState.lvType === 'LV2' ? 'selected' : ''}`}>
              <input
                type="radio"
                className="lv-type-radio"
                value="LV2"
                checked={formState.lvType === 'LV2'}
                onChange={() => handleLvTypeChange('LV2')}
              />
              <span className="lv-type-text">LV2</span>
            </label>

            <label className={`lv-type-option ${formState.lvType === 'LV3' ? 'selected' : ''}`}>
              <input
                type="radio"
                className="lv-type-radio"
                value="LV3"
                checked={formState.lvType === 'LV3'}
                onChange={() => handleLvTypeChange('LV3')}
              />
              <span className="lv-type-text">LV3</span>
            </label>

            <label className={`lv-type-option ${formState.lvType === 'LV4' ? 'selected' : ''}`}>
              <input
                type="radio"
                className="lv-type-radio"
                value="LV4"
                checked={formState.lvType === 'LV4'}
                onChange={() => handleLvTypeChange('LV4')}
              />
              <span className="lv-type-text">LV4</span>
            </label>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '40px' }}>
          <div>
            <h4>LV1</h4>

            <div className="ct-2224">
              <p>V<sub>1U2w</sub> + V<sub>2w1N</sub> = V<sub>1U1N</sub></p>

              <input
                type="text"
                placeholder='Enter Text'
                value={formState.vectorGroupTest.test1}
                onChange={(e) => handleVectorGroupChange('test1', e.target.value)}
              />
            </div>

            <div className="ct-2224">
              <p>V<sub>1W2v</sub> &gt; V<sub>1V2v</sub></p>

              <input
                type="text"
                placeholder='Enter Text'
                value={formState.vectorGroupTest.test2}
                onChange={(e) => handleVectorGroupChange('test2', e.target.value)}
              />
            </div>

            <div className="ct-2224">
              <p>V<sub>1W2w</sub> = V<sub>1V2w</sub></p>

              <input
                type="text"
                placeholder='Enter Text'
                value={formState.vectorGroupTest.test3}
                onChange={(e) => handleVectorGroupChange('test3', e.target.value)}
              />
            </div>
          </div>

          <div>
            <h4>{formState.lvType}</h4>

            {formState.lvType === 'LV2' ? (
              <>
                <div className="ct-2224">
                  <p>V<sub>1U2W</sub> + V<sub>2W1V</sub> = V<sub>1U1V</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv2test1}
                    onChange={(e) => handleVectorGroupChange('lv2test1', e.target.value)}
                  />
                </div>

                <div className="ct-2224">
                  <p>V<sub>1W2W</sub> = V<sub>1V2W</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv2test2}
                    onChange={(e) => handleVectorGroupChange('lv2test2', e.target.value)}
                  />
                </div>

                <div className="ct-2224">
                  <p>V<sub>1W2V</sub> &gt; V<sub>1V2V</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv2test3}
                    onChange={(e) => handleVectorGroupChange('lv2test3', e.target.value)}
                  />
                </div>
              </>
            ) : formState.lvType === 'LV3' ? (
              <>
                <div className="ct-2224">
                  <p>V<sub>1U3W</sub> + V<sub>3W1V</sub> = V<sub>1U1V</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv3test1}
                    onChange={(e) => handleVectorGroupChange('lv3test1', e.target.value)}
                  />
                </div>

                <div className="ct-2224">
                  <p>V<sub>1W3W</sub> = V<sub>1V3W</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv3test2}
                    onChange={(e) => handleVectorGroupChange('lv3test2', e.target.value)}
                  />
                </div>

                <div className="ct-2224">
                  <p>V<sub>1W3V</sub> &gt; V<sub>1V3V</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv3test3}
                    onChange={(e) => handleVectorGroupChange('lv3test3', e.target.value)}
                  />
                </div>
              </>
            ) : (

              <>
                <div className="ct-2224">
                  <p>V<sub>1U4W</sub> + V<sub>4W1V</sub> = V<sub>1U1V</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv4test1}
                    onChange={(e) => handleVectorGroupChange('lv4test1', e.target.value)}
                  />
                </div>

                <div className="ct-2224">
                  <p>V<sub>1W4W</sub> = V<sub>1V4W</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv4test2}
                    onChange={(e) => handleVectorGroupChange('lv4test2', e.target.value)}
                  />
                </div>

                <div className="ct-2224">
                  <p>V<sub>1W4V</sub> &gt; V<sub>1V4V</sub></p>
                  <input
                    type="text"
                    placeholder='Enter Text'
                    value={formState.vectorGroupTest.lv4test3}
                    onChange={(e) => handleVectorGroupChange('lv4test3', e.target.value)}
                  />
                </div>
              </>
            )}
          </div>

          <div className='romeo'>
            <img
              className='vec'
              src={formState.vectorGroupImages.image1}
              alt="Vector Group Triangle 1"
              onError={(e) => {
             
                e.target.style.display = 'none';
              }}
            />
            <img
              className='vec'
              src={formState.vectorGroupImages.image2}
              alt="Vector Group Triangle 2"
              onError={(e) => {
              
                e.target.style.display = 'none';
              }}
            />
            <img
              className='vec'
              src={formState.vectorGroupImages.image3}
              alt="Vector Group Triangle 3"
              onError={(e) => {
              
                e.target.style.display = 'none';
              }}
            />
          </div>
        </div>

      </div>

      <div className="ct-7320-magnetic-balance-test">
        <div className="magnetic-balance-header">
          <h2 className="hello">MAGNETIC BALANCE TEST</h2>
          <div className="test-count-selector">
            <label htmlFor="magnetic-test-count">Number of Taps:</label>
            <select
              id="magnetic-test-count"
              className="test-count-dropdown"
              value={formState.magneticBalanceTaps}
              onChange={handleMagneticBalanceTapsChange}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>

          <div className="test-count-selector">
            <label htmlFor="magnetic-lv-count">Number of LV's:</label>
            <select
              id="magnetic-lv-count"
              className="test-count-dropdown"
              value={formState.magneticBalanceLVs}
              onChange={(e) => updateFormState('magneticBalanceLVs', parseInt(e.target.value, 10))}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
        </div>

        {Array.from({ length: formState.magneticBalanceTaps }).map((_, testIndex) => (
          <div key={testIndex} className="magnetic-balance-test-section">
            <h4 className="test-number-heading">Tap - {testIndex + 1}</h4>


            <div className="ct-7337-winding-card">
              <h2 className="hello">Applied Voltage in HV (V)</h2>
              <div className="ct-7322-table-container">
                <table className="ct-7322-magnetic-table">
                  <thead>
                    <tr>
                      <th className="ct-7324-col-header ct-7325-hv-condition">HV CONDITION</th>
                      <th className="ct-7329-label-span">1U - 1V</th>
                      <th className="ct-7329-label-span">1V - 1W</th>
                      <th className="ct-7329-label-span">1W - 1U</th>
                      <th className="ct-7329-label-span">1U - 1N</th>
                      <th className="ct-7329-label-span">1V - 1N</th>
                      <th className="ct-7329-label-span">1W - 1N</th>
                    </tr>
                  </thead>
                  <tbody>
                    {['1U-1N', '1V-1N', '1W-1N'].map((condition, rowIndex) => (
                      <tr key={rowIndex} className="ct-7331-table-row">
                        <td className="ct-7332-row-label">{condition}</td>
                        {[...Array(6)].map((_, colIndex) => (
                          <td key={colIndex} className="ct-7333-input-cells">
                            <input
                              type="text"
                              className="ct-7334-input-cell"
                              value={formState.magneticBalanceData.hv[testIndex]?.[condition]?.[colIndex] || ""}
                              onChange={(e) => handleMagneticBalanceChange('hv', testIndex, condition, colIndex, e.target.value)}
                              placeholder="Enter value (e.g., >100, <50)"
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>


            {formState.magneticBalanceLVs >= 1 && (
              <div className="ct-7337-winding-card">
                <h2 className="hello">Measured Current in LV1 (V)</h2>
                <div className="ct-7322-table-container">
                  <table className="ct-7322-magnetic-table">
                    <thead>
                      <tr>
                        <th className="ct-7324-col-header ct-7325-hv-condition">HV CONDITION</th>
                        <th className="ct-7329-label-span">2U - 2V</th>
                        <th className="ct-7329-label-span">2V - 2W</th>
                        <th className="ct-7329-label-span">2W - 2U</th>
                      </tr>
                    </thead>
                    <tbody>
                      {['1U-1N', '1V-1N', '1W-1N'].map((condition, rowIndex) => (
                        <tr key={rowIndex} className="ct-7331-table-row">
                          <td className="ct-7332-row-label">{condition}</td>
                          {[...Array(3)].map((_, colIndex) => (
                            <td key={colIndex} className="ct-7333-input-cells">
                              <input
                                type="text"
                                className="ct-7334-input-cell"
                                value={formState.magneticBalanceData.lv[testIndex]?.[condition]?.[colIndex] || ""}
                                onChange={(e) => handleMagneticBalanceChange('lv', testIndex, condition, colIndex, e.target.value)}
                                placeholder="Enter value"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}


            {formState.magneticBalanceLVs >= 2 && (
              <div className="ct-7337-winding-card">
                <h2 className="hello">Measured Current in LV2 (V)</h2>
                <div className="ct-7322-table-container">
                  <table className="ct-7322-magnetic-table">
                    <thead>
                      <tr>
                        <th className="ct-7324-col-header ct-7325-hv-condition">HV CONDITION</th>
                        <th className="ct-7329-label-span">3U - 3V</th>
                        <th className="ct-7329-label-span">3V - 3W</th>
                        <th className="ct-7329-label-span">3W - 3U</th>
                      </tr>
                    </thead>
                    <tbody>
                      {['1U-1N', '1V-1N', '1W-1N'].map((condition, rowIndex) => (
                        <tr key={rowIndex} className="ct-7331-table-row">
                          <td className="ct-7332-row-label">{condition}</td>
                          {[...Array(3)].map((_, colIndex) => (
                            <td key={colIndex} className="ct-7333-input-cells">
                              <input
                                type="text"
                                className="ct-7334-input-cell"
                                value={formState.magneticBalanceData.lv[testIndex]?.[condition]?.[colIndex + 3] || ""}
                                onChange={(e) => handleMagneticBalanceChange('lv', testIndex, condition, colIndex + 3, e.target.value)}
                                placeholder="Enter value"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}


            {formState.magneticBalanceLVs >= 3 && (
              <div className="ct-7337-winding-card">
                <h2 className="hello">Measured Current in LV3 (V)</h2>
                <div className="ct-7322-table-container">
                  <table className="ct-7322-magnetic-table">
                    <thead>
                      <tr>
                        <th className="ct-7324-col-header ct-7325-hv-condition">HV CONDITION</th>
                        <th className="ct-7329-label-span">4U - 4V</th>
                        <th className="ct-7329-label-span">4V - 4W</th>
                        <th className="ct-7329-label-span">4W - 4U</th>
                      </tr>
                    </thead>
                    <tbody>
                      {['1U-1N', '1V-1N', '1W-1N'].map((condition, rowIndex) => (
                        <tr key={rowIndex} className="ct-7331-table-row">
                          <td className="ct-7332-row-label">{condition}</td>
                          {[...Array(3)].map((_, colIndex) => (
                            <td key={colIndex} className="ct-7333-input-cells">
                              <input
                                type="text"
                                className="ct-7334-input-cell"
                                value={formState.magneticBalanceData.lv[testIndex]?.[condition]?.[colIndex + 6] || ""}
                                onChange={(e) => handleMagneticBalanceChange('lv', testIndex, condition, colIndex + 6, e.target.value)}
                                placeholder="Enter value"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}


            {formState.magneticBalanceLVs >= 4 && (
              <div className="ct-7337-winding-card">
                <h2 className="hello">Measured Current in LV4 (V)</h2>
                <div className="ct-7322-table-container">
                  <table className="ct-7322-magnetic-table">
                    <thead>
                      <tr>
                        <th className="ct-7324-col-header ct-7325-hv-condition">HV CONDITION</th>
                        <th className="ct-7329-label-span">5U - 5V</th>
                        <th className="ct-7329-label-span">5V - 5W</th>
                        <th className="ct-7329-label-span">5W - 5U</th>
                      </tr>
                    </thead>
                    <tbody>
                      {['1U-1N', '1V-1N', '1W-1N'].map((condition, rowIndex) => (
                        <tr key={rowIndex} className="ct-7331-table-row">
                          <td className="ct-7332-row-label">{condition}</td>
                          {[...Array(3)].map((_, colIndex) => (
                            <td key={colIndex} className="ct-7333-input-cells">
                              <input
                                type="text"
                                className="ct-7334-input-cell"
                                value={formState.magneticBalanceData.lv[testIndex]?.[condition]?.[colIndex + 9] || ""}
                                onChange={(e) => handleMagneticBalanceChange('lv', testIndex, condition, colIndex + 9, e.target.value)}
                                placeholder="Enter value"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>


      <div className="ct-7335-winding-resistance">
        <div className="winding-resistance-header">
          <h2 className="hello">WINDING RESISTANCE MEASUREMENT</h2>
          <div className="test-count-selector">
            <label htmlFor="lv-count">Number of LV's:</label>
            <select
              id="lv-count"
              className="test-count-dropdown"
              value={formState.numberOfLVs}
              onChange={handleNumberOfLVsChange}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
        </div>
        <br />

        <div className="ct-7322-table-container">
          <table className="ct-7322-magnetic-table">
            <thead>
              <tr>
                <th className="ct-7324-col-header" rowSpan="2">Tap Pos.</th>
                <th className="ct-7324-col-header" colSpan="6">Measured Winding Resistance <br /> <br /> HV Winding</th>
              </tr>
              <tr>
                <th className="ct-7329-label-span" colSpan="2">1U - 1V</th>
                <th className="ct-7329-label-span" colSpan="2">1V - 1W</th>
                <th className="ct-7329-label-span" colSpan="2">1W - 1U</th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: formState.numberOfTaps }).map((_, tapIndex) => {

                const rowData = formState.windingResistance.hvWinding[tapIndex] ||
                  Array(3).fill("").map(() => ({ value: "", unit: "mΩ" }));

                return (
                  <tr key={tapIndex} className="ct-7331-table-row">
                    <td className="ct-7332-row-label">{tapIndex + 1}</td>

                    {[0, 1, 2].map((posIndex) => {
                      const cellData = rowData[posIndex] || { value: "", unit: "mΩ" };

                      return (
                        <React.Fragment key={`hv-${posIndex}`}>
                          <td className="ct-7333-input-cells">
                            <input
                              type="text"
                              className="ct-7334-input-cell"
                              value={cellData.value}
                              onChange={(e) => handleWindingResistanceChange('hvWinding', tapIndex, posIndex, 'value', e.target.value)}
                              placeholder="Enter resistance (e.g., >10, <5)"
                            />
                          </td>
                          <td className="ct-7333-input-cells">
                            <select
                              className="ct-7353-unit-select"
                              value={cellData.unit}
                              onChange={(e) => handleWindingResistanceChange('hvWinding', tapIndex, posIndex, 'unit', e.target.value)}
                            >
                              {windingResistanceUnits.map(unit => (
                                <option key={unit} value={unit}>{unit}</option>
                              ))}
                            </select>
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="ct-7336-card-container">
          {Array.from({ length: formState.numberOfLVs }).map((_, lvIndex) => (
            <div key={lvIndex} className="ct-7337-winding-card">
              <h2 className="hello">LV{lvIndex + 1} Winding</h2>
              <div className="ct-7339-table-container">
                <table className="ct-7340-winding-table">
                  <thead>
                    <tr>
                      <th className="ct-7329-label-span" colSpan="2">{lvIndex + 2}U - {lvIndex + 2}V</th>
                      <th className="ct-7329-label-span" colSpan="2">{lvIndex + 2}V - {lvIndex + 2}W</th>
                      <th className="ct-7329-label-span" colSpan="2">{lvIndex + 2}W - {lvIndex + 2}U</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="ct-7331-table-row">
                      {[0, 1, 2].map((posIndex) => {
                        const cellData = formState.windingResistance[`lv${lvIndex + 1}Winding`]?.[posIndex] || { value: "", unit: "mΩ" };

                        return (
                          <React.Fragment key={`lv${lvIndex + 1}-${posIndex}`}>
                            <td className="ct-7333-input-cells">
                              <input
                                type="text"
                                className="ct-7334-input-cell"
                                value={cellData.value}
                                onChange={(e) => handleWindingResistanceChange(`lv${lvIndex + 1}Winding`, 0, posIndex, 'value', e.target.value)}
                                placeholder="Enter resistance (e.g., >10, <5)"
                              />
                            </td>
                            <td className="ct-7333-input-cells">
                              <select
                                className="ct-7353-unit-select"
                                value={cellData.unit}
                                onChange={(e) => handleWindingResistanceChange(`lv${lvIndex + 1}Winding`, 0, posIndex, 'unit', e.target.value)}
                              >
                                {windingResistanceUnits.map(unit => (
                                  <option key={unit} value={unit}>{unit}</option>
                                ))}
                              </select>
                            </td>
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>


      <div className="ct-7345-bushing-ct">
        <h2 className="hello">BUSHING CT & WR MEASUREMENT</h2>
        <table className="ct-7346-bushing-table">
          <thead className="ct-7347-table-head">
            <tr className="ct-7348-header-row">
              <th className="ct-7349-header-cell">Description</th>
              <th className="ct-7349-header-cell">Terminal</th>
              <th className="ct-7349-header-cell">IR Test Secondary<br />Core to Earth (500 V)</th>
              <th className="ct-7349-header-cell">Winding Resistance Ω</th>
            </tr>
          </thead>
          <tbody className="ct-7350-table-body">
            {formState.bushingData.slice(0, formState.numberOfLVs + 1).map((item, index) => (
              <tr key={index} className="ct-7351-table-row">
                <td className="ct-7352-table-cell">
                  {index < formState.numberOfLVs
                    ? `LV${index + 1} WT1 CT`
                    : "HV WT1 CT"}
                </td>
                <td className="ct-7352-table-cell">{item.terminal}</td>
                <td className="ct-7352-table-cell">
                  <input
                    type="text"
                    className="ct-7353-table-input"
                    value={item.irTest}
                    onChange={(e) => handleBushingDataChange(index, 'irTest', e.target.value)}
                    placeholder="Enter IR test value (e.g., >1000)"
                  />
                </td>
                <td className="ct-7352-table-cell">
                  <input
                    type="text"
                    className="ct-7353-table-input"
                    value={item.windingResistance}
                    onChange={(e) => handleBushingDataChange(index, 'windingResistance', e.target.value)}
                    placeholder="Enter resistance (e.g., <5)"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      <div className="ct-7354-insulation-resistance">
        <h2 className="hello">INSULATION RESISTANCE</h2>
        <table className="ct-7355-insulation-table">
          <thead className="ct-7347-table-head">
            <tr className="ct-7348-header-row">
              <th className="ct-7349-header-cell">Winding Ref</th>
              <th className="ct-7349-header-cell">Applied Voltage</th>
              <th className="ct-7349-header-cell" colSpan="2">1 Min</th>
              <th className="ct-7349-header-cell" colSpan="2">10 Min</th>
              <th className="ct-7349-header-cell">Polarization<br />Index</th>
            </tr>
          </thead>
          <tbody className="ct-7350-table-body">
            {Object.entries(formState.insulationData)
              .filter(([key]) => {

                if (key === "HV-E") return true;


                if (key.startsWith("HV-LV")) {
                  const lvNum = parseInt(key.replace("HV-LV", ""));
                  return lvNum <= formState.numberOfLVs;
                }


                if (key.match(/^LV\d-E$/)) {
                  const lvNum = parseInt(key.replace("LV", "").replace("-E", ""));
                  return lvNum <= formState.numberOfLVs;
                }


                if (key.match(/^LV\d-LV\d$/)) {
                  const [lv1, lv2] = key.split("-").map(lv => parseInt(lv.replace("LV", "")));
                  return lv1 <= formState.numberOfLVs && lv2 <= formState.numberOfLVs;
                }

                return false;
              })
              .map(([key, data], index) => (
                <tr key={index} className="ct-7351-table-row">
                  <td className="ct-7352-table-cell">{key}</td>
                  <td className="ct-7352-table-cell">
                    <select
                      className="ct-7353-unit-select"
                      value={data.appliedVoltage}
                      onChange={(e) => handleInsulationChange(key, "appliedVoltage", e.target.value)}
                    >
                      <option value="">Select Voltage</option>
                      {voltageOptions.map(voltage => (
                        <option key={voltage} value={voltage}>{voltage} V</option>
                      ))}
                    </select>
                  </td>
                  <td className="ct-7352-table-cell">
                    <input
                      type="text"
                      className="ct-7353-table-input"
                      value={data.min1}
                      onChange={(e) => handleInsulationChange(key, "min1", e.target.value)}
                      placeholder="Enter 1 min value (e.g., >100)"
                    />
                  </td>
                  <td className="ct-7352-table-cell">
                    <select
                      className="ct-7353-unit-select"
                      value={data.min1Unit}
                      onChange={(e) => handleInsulationChange(key, "min1Unit", e.target.value)}
                    >
                      {resistanceUnits.map(unit => (
                        <option key={unit} value={unit}>{unit}</option>
                      ))}
                    </select>
                  </td>
                  <td className="ct-7352-table-cell">
                    <input
                      type="text"
                      className="ct-7353-table-input"
                      value={data.min10}
                      onChange={(e) => handleInsulationChange(key, "min10", e.target.value)}
                      placeholder="Enter 10 min value (e.g., <200)"
                    />
                  </td>
                  <td className="ct-7352-table-cell">
                    <select
                      className="ct-7353-unit-select"
                      value={data.min10Unit}
                      onChange={(e) => handleInsulationChange(key, "min10Unit", e.target.value)}
                    >
                      {resistanceUnits.map(unit => (
                        <option key={unit} value={unit}>{unit}</option>
                      ))}
                    </select>
                  </td>
                  <td className="ct-7352-table-cell">
                    <input
                      type="text"
                      className="ct-7353-table-input"
                      value={data.pi}
                      readOnly
                      placeholder="Auto calculated"
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <div className="ct-7356-navigation-buttons">
        <button className="ct-7357-back-button" onClick={handleBack}>Back</button>
        <button className="ct-7358-next-button" onClick={handleNext}>Next</button>
      </div>
    </div>
  );
};

export default TransformerTestForm;















